/**
 * Generates a base64 encoded SHA-256 hash of a given string.
 * @param inputString The string to hash.
 * @returns A promise that resolves to the base64 encoded SHA-256 hash of the input string.
 */
export async function generateBase64Sha256(inputString: string): Promise<string> {
  const encoder: TextEncoder = new TextEncoder();
  const data: Uint8Array = encoder.encode(inputString);
  const hash: ArrayBuffer = await window.crypto.subtle.digest('SHA-256', data);
  let binary = '';
  const bytes: Uint8Array = new Uint8Array(hash);

  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }

  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
